/*
  biberna - Varianten-Vorauswahl, Set-Vorteil-Beschriftung und der kurze
  Weg zum vollstaendigen Set (BIB-AOV-3).

  WARUM
  Der Cross-Sell waehlte bisher "erste lieferbare Variante, deren Farbe
  nicht neutral ist". Bei der Molton-Matratzenauflage stehen die
  Kissengroessen vorne - zu einer Bettwaesche in 135x200 schlug der
  Warenkorb am 12.09.2026 deshalb "Weiss / 1x 80x80 cm" fuer 17,95 EUR
  vor. Richtig waere "1x 100x200 cm" fuer 22,95 EUR gewesen: falsche
  Ware UND 5 EUR weniger Warenkorbwert.

  Gerechnet wird mit assets/biberna-set-match.js - derselben Funktion wie
  auf der Produktseite, mit denselben Tests (test-derive.cjs). Groesse
  schlaegt Farbe, und ohne passende Groesse gibt es keinen Vorschlag.

  DER BETRAG AM KNOPF
  Der hinterlegte Rabatt verlangt ZWEI Zubehoerteile. Am 12.09.2026
  gemessen: Bettwaesche + ein Laken = 73,90 EUR, kein Abzug. Erst das
  zweite Teil loest 16,16 EUR aus.
  Deshalb steht ein Euro-Betrag nur dann am Cross-Sell-Knopf, wenn dieser
  eine Klick den Vorteil tatsaechlich ausloest. Liegt ein Gutschein im
  Korb, steht dort nichts: Der Set-Vorteil kombiniert nicht mit Codes und
  verliert praktisch immer gegen sie.

  EIN KLICK ZUM SET
  Zwei Teile einzeln zu suchen sind zwei Wege durch den Shop - bei einem
  Rabatt, der ohne das zweite Teil gar nicht greift. Die Set-Vorteil-
  Leiste bietet deshalb einen Knopf an, der alle fehlenden Teile
  gleichzeitig in den Korb legt, bereits auf Farbe und Groesse der
  Bettwaesche gematcht. Findet sich fuer eines davon keine passende
  Groesse, wird der Knopf gar nicht erst eingeblendet: Lieber kein
  Angebot als eines, das die falsche Ware liefert.

  NEU RENDERN
  Dawns cart-drawer ersetzt den Inhalt von #CartDrawer per innerHTML.
  Skripte darin laufen nicht erneut, deshalb sitzt dieses hier ausserhalb
  und beobachtet die Aenderung. data-bib-matched verhindert, dass eine
  Auswahl, die die Kundin selbst getroffen hat, wieder ueberschrieben wird.
*/
(function () {
  'use strict';

  /* Kein Regex, keine Backslashes: GraphQL-Blockstrings lassen Backslashes
     woertlich stehen, eine hochgeladene Regex kam am 12.09.2026 doppelt
     escaped und stumm kaputt im Theme an. split/join hat das Problem nicht. */
  function money(cents, fmt) {
    var plain = (cents / 100).toFixed(2);
    var comma = plain.split('.').join(',');
    var whole = String(Math.round(cents / 100));
    var out = fmt || '';
    out = out.split('{{amount_no_decimals_with_comma_separator}}').join(whole);
    out = out.split('{{amount_with_comma_separator}}').join(comma);
    out = out.split('{{amount_no_decimals}}').join(whole);
    out = out.split('{{amount}}').join(plain);
    return out;
  }

  function floorPct(cents, pct) {
    return Math.floor(cents * pct / 100);
  }

  function cartSections() {
    var host = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!host || typeof host.getSectionsToRender !== 'function') return null;
    try {
      return { host: host, ids: host.getSectionsToRender().map(function (s) { return s.id; }) };
    } catch (e) {
      return null;
    }
  }

  /* Das Custom Element biberna-cart-upsell haengt Bild und Preis an ein
     'change' des Selects. Feuern wir zu frueh, steht die Auswahl auf der
     richtigen Variante, waehrend daneben noch der alte Preis steht - am
     12.09.2026 "Weiss / 1x 100x200 cm" ueber "17,95 EUR". */
  function whenUpsellReady(fn) {
    if (window.customElements && typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('biberna-cart-upsell')
        .then(function () { setTimeout(fn, 0); })
        .catch(function () { setTimeout(fn, 100); });
      return;
    }
    setTimeout(fn, 100);
  }

  /* 2026-09-18 (P1-9): Sichtbare Rueckmeldung statt stiller console.warn.
     Haengt am Button, wird per role="alert" auch vorgelesen und raeumt
     sich nach 6 Sekunden selbst wieder ab. */
  function zeigeFehler(button, text) {
    var eltern = button.parentNode;
    if (!eltern) return;
    var box = eltern.querySelector('[data-bib-complete-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-bib-complete-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:0.6rem 0 0;font-size:1.3rem;line-height:1.35;color:#c0392b;';
      eltern.insertBefore(box, button.nextSibling);
    }
    box.textContent = text || 'Das hat gerade nicht geklappt. Bitte noch einmal versuchen.';
    clearTimeout(box._bibTimer);
    box._bibTimer = setTimeout(function () { box.remove(); }, 6000);
  }

  /* Die Leiste bietet an, das Set in einem Zug zu vervollstaendigen. */
  function completeButton(bar) {
    if (!bar || bar.hasAttribute('data-bib-complete-ready')) return;

    var holder = bar.querySelector('[data-bib-complete-data]');
    var button = bar.querySelector('[data-bib-complete]');
    if (!holder || !button) return;

    var data;
    try {
      data = JSON.parse(holder.textContent);
    } catch (e) {
      button.remove();
      return;
    }

    bar.setAttribute('data-bib-complete-ready', '1');

    var matcher = window.bibernaSetMatch;
    if (!matcher || !data.bedding || !data.bedding.size) { button.remove(); return; }

    var offen = data.need - data.accUnits;
    var gewaehlt = [];
    var summe = floorPct(data.accSum, data.pct);

    for (var i = 0; i < data.slots.length && gewaehlt.length < offen; i++) {
      var slot = data.slots[i];
      if (slot.inCart) continue;

      var live = (slot.variants || []).filter(function (v) { return v.available; });
      var hit = matcher.deriveSelection(data.bedding, live, slot.hasColor === true, data.rules);
      if (!hit) continue;

      var treffer = null;
      for (var j = 0; j < live.length; j++) {
        if (live[j].size !== hit.size) continue;
        if (slot.hasColor === true && live[j].color !== hit.color) continue;
        treffer = live[j];
        break;
      }
      if (!treffer) continue;

      gewaehlt.push(treffer);
      summe += floorPct(treffer.price, data.pct);
    }

    /* Nicht genug passende Ware gefunden - dann kein Angebot. */
    if (gewaehlt.length < offen) { button.remove(); return; }

    button.hidden = false;
    button.textContent = 'Set komplett machen · ' + money(summe, data.moneyFormat) + ' sparen';

    button.addEventListener('click', function () {
      button.disabled = true;
      var vorher = button.textContent;
      button.textContent = 'Moment …';

      var payload = {
        items: gewaehlt.map(function (v) { return { id: Number(v.id), quantity: 1 }; })
      };
      var sec = cartSections();
      if (sec) {
        payload.sections = sec.ids;
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        /* 2026-09-18 (P1-9): Frueher wurde die Antwort ungeprueft mit
           r.json() gelesen. Bei 422 - die Variante war zwischen Anzeige
           und Klick ausverkauft - enthaelt der Body ein Fehlerobjekt OHNE
           'sections'. Der else-Zweig loeste dann einen kompletten
           Seiten-Reload aus: Der Drawer schloss sich, der Artikel fehlte,
           und der Nutzer sah keinerlei Erklaerung. */
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) {
              /* Shopify liefert je nach Fehlerart 'description' oder 'message'. */
              throw new Error(body.description || body.message || 'Warenkorb gerade nicht erreichbar.');
            }
            return body;
          });
        })
        .then(function (body) {
          if (sec && body.sections && typeof sec.host.renderContents === 'function') {
            sec.host.renderContents(body);
          } else {
            /* Erfolgreich hinzugefuegt, nur ohne Sections - nur hier ist
               ein Reload noch vertretbar. */
            window.location.reload();
          }
        })
        .catch(function (err) {
          if (window.console) console.warn('[biberna] Set nicht vervollstaendigt:', err);
          button.disabled = false;
          button.textContent = vorher;
          zeigeFehler(button, err && err.message);
        });
    });
  }

  function apply(root) {
    if (!root || root.hasAttribute('data-bib-matched')) return;

    var holder = root.querySelector('[data-bib-upsell-match]');
    var select = root.querySelector('[data-bib-upsell-select]');
    var button = root.querySelector('[data-bib-upsell-add]');
    if (!holder || !select || !button) return;

    var data;
    try {
      data = JSON.parse(holder.textContent);
    } catch (e) {
      if (window.console) console.warn('[biberna] Cross-Sell-Daten nicht lesbar:', e);
      return;
    }

    root.setAttribute('data-bib-matched', '1');

    var matcher = window.bibernaSetMatch;
    var live = (data.variants || []).filter(function (v) { return v.available; });

    /* 1. Passende Variante vorwaehlen. */
    if (matcher && data.bedding && data.bedding.size && live.length) {
      var hit = matcher.deriveSelection(data.bedding, live, data.hasColor === true, data.rules);
      if (hit) {
        var match = null;
        for (var i = 0; i < live.length; i++) {
          if (live[i].size !== hit.size) continue;
          if (data.hasColor === true && live[i].color !== hit.color) continue;
          match = live[i];
          break;
        }
        if (match) {
          var ids = Array.prototype.map.call(select.options, function (o) { return o.value; });
          if (ids.indexOf(String(match.id)) !== -1) {
            select.value = String(match.id);
            whenUpsellReady(function () {
              select.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }
        }
      }
    }

    /* 2. Betrag am Knopf - nur wenn dieser Klick den Vorteil ausloest. */
    var baseLabel = button.textContent.trim() || 'Hinzufügen';

    function saveLabelOf(id) {
      for (var i = 0; i < live.length; i++) {
        if (String(live[i].id) === String(id)) return live[i].saveLabel || null;
      }
      return null;
    }

    function refreshLabel() {
      var triggers = data.qualifies === true &&
        data.hasCode !== true &&
        data.accUnits === data.need - 1;

      var label = triggers ? saveLabelOf(select.value) : null;
      button.textContent = label ? baseLabel + ' · ' + label + ' sparen' : baseLabel;
    }

    select.addEventListener('change', refreshLabel);
    refreshLabel();
  }

  function scan() {
    var list = document.querySelectorAll('[data-bib-upsell]');
    for (var i = 0; i < list.length; i++) apply(list[i]);

    var bars = document.querySelectorAll('[data-bib-setbar]');
    for (var k = 0; k < bars.length; k++) completeButton(bars[k]);
  }

  function watch() {
    var host = document.querySelector('#CartDrawer');
    if (host && window.MutationObserver) {
      new MutationObserver(function () { scan(); }).observe(host, { childList: true, subtree: true });
    }
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(scan, 0); });
    }
  }

  function init() {
    scan();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
